export var TOGGLE_BURGER = 'TOGGLE_BURGER';
export var OPEN_BURGER = 'OPEN_BURGER';
export var CLOSE_BURGER = 'CLOSE_BURGER';